/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import moment from 'moment/moment';
import { getCompetitons } from '../../store/actions';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMonth } from '../../data/format-month';
import { base } from '../../store/api';
import Loading from '../../component/Loading';

const BlogSidebar = (props) => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const dispatch = useDispatch();
  const language = localStorage.getItem('i18nextLng');
  const [loading, setLoading] = useState(true);
  const formatDate = (date) => {
    const month = date?.split('T')[0].split('-')[1];
    return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY`)}`;
  };

  useEffect(() => {
    const lang = language === 'tm' ? 'tk' : language;
    let params = {
      limit: 7,
      offset: 0,
    };
    setLoading(true);
    getCompetitons(dispatch, params, lang, (err, res) => {
      if (err) console.log(err);
      setNews(res?.results);
      setLoading(false);
    });
  }, [language]);

  return (
    <div className="sidebar-widget-wrapper tw-w-full">
      <div className="sidebar__widget mb-30">
        <div className="sidebar__widget-head mb-35">
          <h4 className="sidebar__widget-title">{t('other_competitions')}</h4>
        </div>
        <div className="sidebar__widget-content">
          {loading ? (
            <div className="tw-w-full tw-flex tw-flex-row tw-justify-center tw-items-center">
              <Loading style={{ width: '30%' }} />
            </div>
          ) : (
            <div className="rc__post-wrapper">
              {news.map((item) => {
                return (
                  item.id !== Number(props.news_id) && (
                    <Link to={`/competition-details/${item.id}`}>
                      <div
                        key={item.id}
                        // className="rc__post d-flex align-items-center"
                        className="rc__post tw-flex tw-flex-row tw-gap-x-2.5"
                      >
                        <div className="tw-basis-1/2 tw-w-full tw-aspect-[3/2]">
                          {item.thumbnail && (
                            <img
                              width={300}
                              height={200}
                              className="tw-w-full tw-aspect-[3/2] tw-object-cover"
                              src={`${base}${item.thumbnail}`}
                              alt={item.title}
                            />
                          )}
                        </div>
                        <div className="tw-basis-1/2 tw-flex tw-flex-col tw-gap-y-2.5">
                          <div className="tw-text-sm tw-text-gray-400">{formatDate(item.start_date)}</div>
                          <div className="tw-font-semibold">
                            <div className="tw-line-clamp-2 tw-text-black tw-transition-colors tw-duration-300 group-hover:tw-text-primary">{item.title}</div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
